export const exemptionStatusColor = {
  EXEMPTION: 'red'
};

export const amendmentModificationColor = {
  EDIT: 'purple'
};

export const userRoles = {
  GUEST: 'green',
  USER: 'blue',
  'SUPER-USER': 'geekblue',
  ADMIN: 'red',
  'SUPER-ADMIN': 'magenta'
};

export const invoiceTypes = {
  PAY: 'blue',
  DEPOSIT: 'green',
  CREDIT: 'magenta'
};

export const zonesColors = {
  1: '#f368e0',
  2: '#ff9f43',
  3: '#ee5253',
  4: '#0abde3',
  5: '#10ac84',
  6: '#5C20E9',
  7: '#E9DC20',
  8: '#592900'
};

export const ticketsPriorities = ['NORMAL', 'HIGH', 'URGENT'];

export const ticketsPrioritiesColor = {
  LOW: 'blue',
  NORMAL: 'green',
  HIGH: 'orange',
  URGENT: 'red'
};

export const ticketsTypes = ['PICKUP', 'THEFT', 'LOSS', 'DAMAGED'];

export const ticketsTypesColor = {
  PICKUP: 'green',
  THEFT: 'volcano',
  LOSS: 'cyan',
  DAMAGED: 'red'
};

export const tasksStatuses = {
  IN_PROGRESS: 'blue',
  AWAITING_INFORMATION: 'cyan',
  ACCEPTED: 'green',
  PENDING_COMPANY: 'purple',
  PENDING_REFERENT: 'purple',
  REFUSED: 'red',
  WITHOUT_EFFECT: 'orange'
};

export const tasksPriorities = {
  URGENT: 'red',
  HIGH: 'yellow',
  NORMAL: 'cyan',
  LOW: 'grey'
};

export const projectsStatuses = {
  OPEN: 'blue',
  PENDING: 'green',
  'IN PROGRESS': 'orange',
  AUDITED: 'cyan',
  CLOSED: 'red',
  CANCELED: 'red'
};

export const companiesTypes = {
  CUSTOMERS: 'blue',
  SUPPLIERS: 'green'
};

export const contractsStatuses = {
  QUOTE: 'blue',
  ACTIVE: 'green',
  UNPAID_1: 'volcano',
  UNPAID_2: 'volcano',
  UNPAID_3: 'volcano',
  FORMAL_NOTICE: 'volcano',
  WARRANTY_SUSPENSION: 'volcano',
  TERMINATED: 'volcano',
  TERMINATED_NON_PAYMENT: 'volcano',
  WITHOUT_EFFECT: 'orange',
  ACTIVE_AFTER_SUSPENSION: 'green'
};

export const contractsTypes = {
  MRP: 'blue',
  MRPWK: 'blue',
  MRPCM: 'blue',
  MRPML: 'blue',
  RCP: 'green',
  RCPWK: 'green',
  RCPHX: 'green',
  RCPCM: 'green',
  RCPML: 'green',
  RCNGAWK: 'purple',
  PJPART: 'orange',
  PJPRO: 'yellow',
  PREVOYANCE: 'cyan',
  DO: 'green',
  RCGLS: 'rose'
};

export const customerStatuses = {
  PROSPECT: 'orange',
  ACTIVE: 'blue'
};

export const quittanceStatuses = {
  PAID: 'green',
  NOT_PAID: 'blue'
};
